import './billing-form.styles.scss';
import FormField from '../form-field/form-field.component';
import SelectField from '../select-field/select-field.component';
import { Box } from '@mui/material';

const stateList = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
  'DF',
];

const genderOptions = ['Masculino', 'Feminino'];

const BillingForm = ({ billingInfo, onChange, errors }) => {
  const {
    fullName,
    cpf,
    email,
    phone,
    cep,
    address,
    addressNumber,
    neighborhood,
    otherInfo,
    city,
    state,
    birthDate,
    gender,
  } = billingInfo;

  // Busca o endereço pelo CEP (API gratuita ViaCEP) e preenche os campos.
  const fetchAddressByCep = async (cepDigits, current) => {
    try {
      const response = await fetch(`https://viacep.com.br/ws/${cepDigits}/json/`);
      const data = await response.json();
      if (!data.erro) {
        onChange({
          ...current,
          address: data.logradouro || current.address,
          neighborhood: data.bairro || current.neighborhood,
          city: data.localidade || current.city,
          state: data.uf || current.state,
        });
      }
    } catch (error) {
      // Falha silenciosa: o usuário ainda pode preencher manualmente.
      console.warn('Não foi possível buscar o endereço pelo CEP:', error);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    const updated = { ...billingInfo, [name]: value };
    onChange(updated);

    // Ao completar o CEP (8 dígitos), busca o endereço automaticamente.
    if (name === 'cep') {
      const cepDigits = value.replace(/\D/g, '');
      if (cepDigits.length === 8) {
        fetchAddressByCep(cepDigits, updated);
      }
    }
  };

  const getErrorMessage = (fieldName) => {
    return !!errors ? errors[fieldName] : null;
  };

  return (
    <Box
      className="passenger-form-container"
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)',
        },
        columnGap: 2,
        rowGap: { xs: 4, md: 4 },
      }}
    >
      <FormField
        type="text"
        label="Nome completo"
        name="fullName"
        variant="light"
        required
        onChange={handleChange}
        value={fullName}
        errorMessage={getErrorMessage('fullName')}
      />
      <FormField
        type="text"
        label="CPF"
        name="cpf"
        variant="light"
        required
        onChange={handleChange}
        value={cpf}
        mask="999.999.999-99"
        errorMessage={getErrorMessage('cpf')}
      />
      <SelectField
        label="Sexo"
        type="text"
        name="gender"
        variant="light grey"
        required
        onChange={handleChange}
        value={gender}
        options={genderOptions}
      />
      <FormField
        label="Data de nascimento"
        name="birthDate"
        variant="light"
        required
        onChange={handleChange}
        value={birthDate}
        mask="99/99/9999"
        errorMessage={getErrorMessage('birthDate')}
      />
      <FormField
        type="email"
        label="E-mail"
        name="email"
        variant="light"
        required
        onChange={handleChange}
        value={email}
        errorMessage={getErrorMessage('email')}
      />
      <FormField
        type="text"
        label="Telefone"
        name="phone"
        variant="light"
        required
        onChange={handleChange}
        value={phone}
        mask="(99) 99999-9999"
        errorMessage={getErrorMessage('phone')}
      />
      <FormField
        type="text"
        label="CEP"
        name="cep"
        variant="light"
        required
        onChange={handleChange}
        value={cep}
        mask="99999-999"
        errorMessage={getErrorMessage('cep')}
      />
      <FormField
        type="text"
        label="Endereço"
        name="address"
        variant="light"
        required
        onChange={handleChange}
        value={address}
        errorMessage={getErrorMessage('address')}
      />
      <FormField
        type="number"
        label="Número"
        name="addressNumber"
        variant="light"
        required
        onChange={handleChange}
        value={addressNumber}
        errorMessage={getErrorMessage('addressNumber')}
      />
      <FormField
        type="text"
        label="Complemento (opcional)"
        name="otherInfo"
        variant="light"
        onChange={handleChange}
        value={otherInfo}
        errorMessage={getErrorMessage('otherInfo')}
      />
      <FormField
        type="text"
        label="Cidade"
        name="city"
        variant="light"
        required
        onChange={handleChange}
        value={city}
        errorMessage={getErrorMessage('city')}
      />

      <SelectField
        type="text"
        label="Estado"
        name="state"
        variant="light grey"
        autocomplete="off"
        required
        onChange={handleChange}
        value={state}
        options={stateList}
      />
    </Box>
  );
};

export default BillingForm;
